import React from "react";
import { Dialog, DialogTitle, IconButton, Typography } from "@mui/material";
import {
  StyledTitle,
  StyledSubTitle,
  StyledDialogContent,
  StyledBox,
  StyledContainedButton,
} from "./style";
import { CustomTextField } from '../CustomTextField';
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import useGlobalContext from "../../../contexts-hooks/hooks/useGlobalContext";
import { useChangePasswordManagement } from './useChangePassword'

const ChangePasswordPopup = ({ open, onClose }) => {
  const { state } = useGlobalContext();
  const {
    formik,
    showCurrentPassword,
    showNewPassword,
    showConfirmPassword,
    toggleCurrentPasswordVisibility,
    toggleNewPasswordVisibility,
    toggleConfirmPasswordVisibility,
  } = useChangePasswordManagement(onClose);

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      BackdropProps={{
        style: {
          backgroundColor: "rgba(0, 1, 0, 0.2)",
          backdropFilter: "blur(5px)",
          WebkitBackdropFilter: "blur(5px)",
        },
      }}
    >
      <DialogTitle>
        <StyledTitle variant="h5">
          Welcome {state?.user?.name}{" "}
        </StyledTitle>
        <StyledSubTitle variant="h6">
          Please change your default password
        </StyledSubTitle>
      </DialogTitle>

      <StyledDialogContent>
        {formik.errors.submit && (
          <Typography color="error" sx={{ mb: 2 }}>
            {formik.errors.submit}
          </Typography>
        )}

        <form onSubmit={formik.handleSubmit}>
          <CustomTextField
            id="currentPassword"
            name="currentPassword"
            label="Current Password"
            type={showCurrentPassword ? "text" : "password"}
            fullWidth
            margin="normal"
            value={formik.values.currentPassword}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.currentPassword &&
              Boolean(formik.errors.currentPassword)
            }
            helperText={
              formik.touched.currentPassword && formik.errors.currentPassword
            }
            InputProps={{
              endAdornment: (
                <IconButton onClick={toggleCurrentPasswordVisibility}>
                  {showCurrentPassword ? (
                    <VisibilityOffIcon />
                  ) : (
                    <VisibilityIcon />
                  )}
                </IconButton>
              ),
            }}
          />
          <CustomTextField
            id="newPassword"
            name="newPassword"
            label="New Password"
            type={showNewPassword ? "text" : "password"}
            fullWidth
            margin="normal"
            value={formik.values.newPassword}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.newPassword && Boolean(formik.errors.newPassword)
            }
            helperText={formik.touched.newPassword && formik.errors.newPassword}
            InputProps={{
              endAdornment: (
                <IconButton onClick={toggleNewPasswordVisibility}>
                  {showNewPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </IconButton>
              ),
            }}
          />
          <CustomTextField
            id="confirmNewPassword"
            name="confirmNewPassword"
            label="Confirm New Password"
            type={showConfirmPassword ? "text" : "password"}
            fullWidth
            margin="normal"
            value={formik.values.confirmNewPassword}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.confirmNewPassword &&
              Boolean(formik.errors.confirmNewPassword)
            }
            helperText={
              formik.touched.confirmNewPassword &&
              formik.errors.confirmNewPassword
            }
            InputProps={{
              endAdornment: (
                <IconButton onClick={toggleConfirmPasswordVisibility}>
                  {showConfirmPassword ? (
                    <VisibilityOffIcon />
                  ) : (
                    <VisibilityIcon />
                  )}
                </IconButton>
              ),
            }}
          />

          <StyledBox>
            <StyledContainedButton
              type="submit"
            >
              Change Password
            </StyledContainedButton>
          </StyledBox>
        </form>
      </StyledDialogContent>
    </Dialog>
  );
};

export default ChangePasswordPopup;
